import "../styles/cgu.scss"

function Mentions(){

    return (
        <div className="blocpage">

            <h1>Mentions légales</h1>

<h2>1. Éditeur du site</h2>
<p>
Le présent site est édité par :<br></br>

BMDev<br></br>
Micro-entreprise<br></br>
SIRET : 9409122490001<br></br>
Siège social : 1 rue du soleil levant, 92140 Clamart<br></br>
Email : briconnectapp@gmail.com<br></br>

Le responsable de la publication est : Bruce Monnerville
</p>
<h2>2. Hébergement</h2>
<p>
Le site est hébergé par :<br></br>

Vercel Inc.<br></br>
440 N Barranca Ave #4133<br />
Covina, CA 91723<br />
États-Unis<br />
Site web : https://vercel.com
</p>
<h2>3. Propriété intellectuelle</h2>
<p>
L’ensemble du contenu du site (textes, images, logos, éléments graphiques, structure, etc.) est la propriété exclusive de BMDev, sauf mention contraire.<br></br>

Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation préalable est interdite.
</p>

<h2>4. Responsabilité</h2>
<p>
BMDev met tout en œuvre pour assurer l’exactitude des informations diffusées sur le site.<br></br>

Toutefois, l’éditeur ne saurait être tenu responsable :<br></br>

Des erreurs ou omissions<br></br>
D’une indisponibilité du service<br></br>
De tout dommage résultant de l’utilisation du site<br></br>

La plateforme agit uniquement en tant qu’intermédiaire de mise en relation entre utilisateurs.
</p>

<h2>5. Données personnelles</h2>
<p>
Les informations collectées via le site sont traitées conformément à la réglementation en vigueur.<br></br>

Pour en savoir plus, consultez la Politique de confidentialité.
</p>

<h2>6. Cookies</h2>
<p>
Le site peut utiliser des cookies afin d’améliorer l’expérience utilisateur et mesurer l’audience.<br></br>

L’utilisateur peut configurer ses préférences via son navigateur.
</p>

<h2>7. Contact</h2>
<p>
Pour toute question ou demande d’information :<br></br>

Email : briconnectapp@gmail.com
</p>
        </div>
    )

}

export default Mentions